import { Link } from 'react-router-dom'
import type { VisibleWorkflowWindow, WorkflowStep } from './types'
import './ComplianceWorkflowTrail.css'

interface Props {
  visible: VisibleWorkflowWindow
  isOverview?: boolean
}

export default function ComplianceWorkflowTrailPreview({ visible, isOverview }: Props) {
  const { steps, hasLeadingEllipsis, hasTrailingEllipsis, currentIndex } = visible

  return (
    <nav className="compliance-workflow-trail" aria-label="Compliance workflow preview">
      <span className="compliance-workflow-trail__label">Workflow</span>
      {hasLeadingEllipsis && <span className="compliance-workflow-trail__ellipsis" aria-hidden>…</span>}
      {steps.map((step, i) => {
        const globalIndex = visible.startIndex + i
        const isCurrent = !isOverview && currentIndex === globalIndex
        return (
          <span key={step.key} className="d-inline-flex align-items-center">
            {i > 0 && <span className="compliance-workflow-trail__sep" aria-hidden>·</span>}
            <StepChip step={step} isCurrent={isCurrent} />
          </span>
        )
      })}
      {hasTrailingEllipsis && <span className="compliance-workflow-trail__ellipsis" aria-hidden>…</span>}
    </nav>
  )
}

function StepChip({ step, isCurrent }: { step: WorkflowStep; isCurrent: boolean }) {
  const content = (
    <>
      <span className="compliance-workflow-trail__num">{step.sortOrder}</span>
      <span>{step.shortLabel}</span>
    </>
  )
  if (isCurrent) {
    return (
      <span className="compliance-workflow-trail__step compliance-workflow-trail__step--current" aria-current="step">
        {content}
      </span>
    )
  }
  return (
    <Link to={step.primaryRoute} className="compliance-workflow-trail__step" title={step.title}>
      {content}
    </Link>
  )
}
